'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaMapO = function FaMapO(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.2 2.8q0.6 0.4 0.6 1.1v27.3q0 0.4-0.3 0.7t-0.5 0.4l-12.4 5q-0.5 0.2-1 0l-11.9-4.8-12 4.8q-0.2 0.1-0.5 0.1-0.3 0-0.7-0.2-0.5-0.4-0.5-1.1v-27.3q0-0.4 0.2-0.7t0.6-0.4l12.4-5q0.5-0.2 0.9 0l12 4.8 11.9-4.8q0.7-0.2 1.2 0.1z m-24.9 2.6v24.7l11.2 4.5v-24.7z m-11.8 4.3v24.6l10.5-4.2v-24.7z m34.8 20.6v-24.6l-10.6 4.2v24.7z' })
        )
    );
};

exports.default = FaMapO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/map-o.js
// module id = 1577
// module chunks = 0